// // src/components/dermatology/DermSummaryTab.tsx
// import React, { useEffect, useState } from "react";
// import "../../css/DermSummaryTab.css";
// import DermReportSection from "./DermReportSection";
// import api from "../../api/axiosConfig";
// import { ReportRecommendations } from "../../pages/DermatologyScreen";

// interface DermTabProps {
//   emrId: string;
//   patientAge: number;
//   doctorName: string;
//   userId: string;
//   activeSubTab?: "derma" | "ad";
//   telePrognosis: string;
//   setTelePrognosis: (value: string) => void;
//   medicalAdvice: string;
//   setMedicalAdvice: (value: string) => void;
//   recommendations: ReportRecommendations;
//   setRecommendations: (recommendations: ReportRecommendations) => void;
//   onSubmitSuccess?: () => void;
//   showADTab?: boolean;
// }

// const DermSummaryTab: React.FC<DermTabProps> = (props) => {
//   const [exam, setExam] = useState<any>(null);
//   const [hasPruritus, setHasPruritus] = useState<boolean | null>(null);
//   const [hasChronicRelapsing, setHasChronicRelapsing] = useState<
//     boolean | null
//   >(null);
//   const [hasTypicalMorphology, setHasTypicalMorphology] = useState<
//     boolean | null
//   >(null);
//   const [hasFamilyHistory, setHasFamilyHistory] = useState<boolean | null>(
//     null,
//   );
//   const [minorSymptoms, setMinorSymptoms] = useState<Record<string, boolean>>(
//     {},
//   );
//   const [igeCount, setIgeCount] = useState<number | null>(null);

//   const activeSubTab = props.activeSubTab || "derma";

//   const getYesNoClass = (value: string) => {
//     if (value === "Yes") return "yes-text";
//     if (value === "No") return "no-text";
//     return "";
//   };

//   // useEffect(() => {
//   //   const fetchData = async () => {
//   //     try {
//   //       // Physical Exam
//   //       const examRes = await api.dataCollectionApi.get(
//   //         `/api/forms/physical-exam/${props.emrId}`,
//   //       );
//   //       setExam(examRes?.data?.data);

//   //       // 🔥 SINGLE HEALTH API CALL
//   //       const healthRes = await api.Questionnair.get(
//   //         `/api/answers/getans/${props.emrId}`,
//   //         {
//   //           params: { category: "health" },
//   //         },
//   //       );

//   //       const answers = healthRes?.data?.data?.[0]?.answers || [];

//   //       const findAnswer = (id: string) =>
//   //         answers.find((a: any) => a.questionId === id)?.value === true;

//   //       setHasChronicRelapsing(findAnswer("AM_01"));
//   //       setHasPruritus(findAnswer("AM_02"));
//   //       setHasTypicalMorphology(findAnswer("AM_03"));
//   //       setHasFamilyHistory(findAnswer("AM_09"));
//   //     } catch (err) {
//   //       console.error("Failed to fetch dermatology summary data", err);
//   //     }
//   //   };

//   //   fetchData();
//   // }, []);


// //   useEffect(() => {
// //   const fetchData = async () => {
// //     try {
// //       // Temporary static EMR for testing
// //       const currentEmr = "P-2026-000049-9";

// //       // Physical Exam
// //       const examRes = await api.dataCollectionApi.get(
// //         `/api/forms/physical-exam/${currentEmr}`
// //       );

// //       setExam(examRes?.data?.data);

// //       // Correct scoring API
// //       const healthRes = await api.dataCollectionApi.get(
// //         `/questionnair/api/scoring/scoresId/${currentEmr}/health`
// //       );

// //       const results = healthRes?.data?.scores?.resultsById || {};

// //       // AD visibility answer
// //       const adAnswer = String(results["1220"] || "").toLowerCase();

// //       console.log("1220 answer =", adAnswer);

// //       // Major symptoms
// //       setHasChronicRelapsing(adAnswer === "yes");
// //       setHasPruritus(adAnswer === "yes");
// //       setHasTypicalMorphology(adAnswer === "yes");
// //       setHasFamilyHistory(adAnswer === "yes");

// //     } catch (err) {
// //       console.error("Failed to fetch dermatology summary data", err);
// //     }
// //   };

// //   fetchData();
// // }, []);


// // useEffect(() => {
// //   const fetchData = async () => {
// //     try {
// //       const currentEmr = props.emrId;

// //       if (!currentEmr) return;

// //       const examRes = await api.dataCollectionApi.get(
// //         `/api/forms/physical-exam/${currentEmr}`
// //       );

// //       setExam(examRes?.data?.data);
// //       const currentEmr1="P-2026-000049-9"

// //       const healthRes = await api.dataCollectionApi.get(
// //         `/questionnair/api/scoring/scoresId/${currentEmr1}/health`
// //       );

// //       const results =
// //         healthRes?.data?.scores?.resultsById || {};

// //       const adAnswer = String(
// //         results["1220"] || ""
// //       ).toLowerCase();

// //       setHasChronicRelapsing(
// //         adAnswer === "yes" ||
// //         adAnswer === "maybe"
// //       );

// //       setHasPruritus(
// //         adAnswer === "yes" ||
// //         adAnswer === "maybe"
// //       );

// //       setHasTypicalMorphology(
// //         adAnswer === "yes" ||
// //         adAnswer === "maybe"
// //       );

// //       setHasFamilyHistory(
// //         adAnswer === "yes" ||
// //         adAnswer === "maybe"
// //       );

// //     } catch (err) {
// //       console.error(
// //         "Failed to fetch dermatology summary data",
// //         err
// //       );
// //     }
// //   };

// //   fetchData();
// // }, [props.emrId]);


// // 🔥 Main Fetch Block (Dynamic EMR for both exam and health score)
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const currentEmr = props.emrId;

//         if (!currentEmr) return;

//         // 1. Dynamic EMR for physical exam
//         const examRes = await api.dataCollectionApi.get(
//           `/api/forms/physical-exam/${currentEmr}`
//         );
//         setExam(examRes?.data?.data);

//         // 2. Dynamic EMR for health scores (Now uses the actual patient EMR)
//         const healthRes = await api.dataCollectionApi.get(
//           `/questionnair/api/scoring/scoresId/${currentEmr}/health`
//         );

//         const results = healthRes?.data?.scores?.resultsById || {};
//         const adAnswer = String(results["1220"] || "").toLowerCase();

//         setHasChronicRelapsing(adAnswer === "yes" || adAnswer === "maybe");
//         setHasPruritus(adAnswer === "yes" || adAnswer === "maybe");
//         setHasTypicalMorphology(adAnswer === "yes" || adAnswer === "maybe");
//         setHasFamilyHistory(adAnswer === "yes" || adAnswer === "maybe");

//       } catch (err) {
//         console.error("Failed to fetch dermatology summary data", err);
//       }
//     };

//     fetchData();
//   }, [props.emrId]);



//   const yesNo = (arr: string[] | undefined, key: string) =>
//     arr?.includes(key) ? "Yes" : "No";

//   // 🔥 Dynamic symptom checker
//   const hasAnyYes = (values: (boolean | undefined | null)[]) =>
//     values.some((v) => v === true);

//   const hasAnyFromArray = (arr: string[] | undefined) =>
//     Array.isArray(arr) && arr.length > 0;

//   // 🔥 Separate Minor Symptoms API (Testing EMR)
//   useEffect(() => {
//     const fetchMinorSymptoms = async () => {
//       try {
//         const response = await api.dataCollectionApi.get(
//           `/api/forms/atopic-dermatitis/${props.emrId}`,
//         );

//         const features = response?.data?.data?.features || [];

//         const featureMap: Record<string, boolean> = {};

//         features.forEach((feature: any) => {
//           featureMap[feature.code] = feature.observed === true;
//         });

//         setMinorSymptoms(featureMap);
//       } catch (error) {
//         console.error("Failed to fetch minor symptoms", error);
//       }
//     };

//     fetchMinorSymptoms();
//  }, [props.emrId]);

//   // 🔥 Separate IgE Count API (Testing EMR)
//   useEffect(() => {
//     const fetchIgeCount = async () => {
//       try {
//         const response = await api.dataCollectionApi.get(
//           `/api/forms/lab-report/${props.emrId}`,
//         );

//         const igeValue =
//           response?.data?.data?.["Immunoglobulin E (Total IgE)"]?.[
//             "Immunoglobulin E"
//           ] ?? null;

//         setIgeCount(igeValue);
//       } catch (error) {
//         console.error("Failed to fetch IgE count", error);
//         setIgeCount(null);
//       }
//     };

//     fetchIgeCount();
//   }, []);

//   // 🔥 Submit Dermatology Report (with validation + auto reset)
//   const handleSubmitReport = async () => {
//     // 1️⃣ Validation: Tele-Prognosis
//     if (!props.telePrognosis.trim()) {
//       alert("Please enter Tele-Prognosis");
//       return;
//     }

//     // 2️⃣ Validation: Medical Advice
//     if (!props.medicalAdvice.trim()) {
//       alert("Please enter Medical Advice");
//       return;
//     }

//     // 3️⃣ Validation: At least one recommendation checked
//     const selectedRecommendations = Object.entries(props.recommendations)
//       .filter(([_, value]) => value === true)
//       .map(([key]) => key);

//     if (selectedRecommendations.length === 0) {
//       alert("Please select at least one Recommendation");
//       return;
//     }

//     try {
//       const payload = {
//         emrId: props.emrId,
//         chartType: "primary",
//         age: props.patientAge, // TODO: dynamic later
//         doctorName: props.doctorName, // TODO: from auth later
//         reportWriting: {
//           telePrognosis: props.telePrognosis,
//           medicalAdvice: props.medicalAdvice,
//           recommendations: selectedRecommendations,
//         },
//         createdBy: "doctor_user",
//       };

//       const response = await api.dataCollectionApi.post(
//         "/teledocs/dermatology/report/submit",
//         payload,
//       );

//       console.log("Report Submitted Successfully:", response.data);

//       // // ✅ 4️⃣ AUTO RESET AFTER SUCCESS
//       // handleResetReport();

//       handleResetReport();

//       if (props.onSubmitSuccess) {
//         props.onSubmitSuccess();
//       }
//     } catch (error) {
//       console.error("Failed to submit report", error);
//       alert("Failed to submit report");
//     }
//   };

//   // 🔥 Reset Report Writing Section
//   const handleResetReport = () => {
//     props.setTelePrognosis("");
//     props.setMedicalAdvice("");

//     props.setRecommendations({
//       none: false,
//       followAdvice: false,
//       consultDerm: false,
//     });
//   };

//   return (
//     <div className="derm-summary-container">
//       <h3 className="summary-title">Findings Overview</h3>

//       <div className="findings-grid">
//         {/* ===== DERMA SYMPTOMS ===== */}
//         {activeSubTab === "derma" && (
//           <>
//             {/* --- Oral Cavity --- */}
//             <div className="finding-card">
//               <div className="card-header">
//                 <h4>Oral Cavity</h4>
//               </div>

//               <div className="card-body">
//                 <p>
//                   <span className="date-icon">📅</span>{" "}
//                   <strong>Onset Date:</strong>{" "}
//                   {exam?.oralCavity?.onsetDate?.split("T")[0]}
//                 </p>
//                 <p>
//                   <strong>Location:</strong>
//                 </p>
//                 <div className="two-column-grid">
//                   <div>
//                     Buccal Cavity:
//                     <span
//                       className={getYesNoClass(
//                         yesNo(exam?.oralCavity?.findings, "Buccal Cavity"),
//                       )}
//                     >
//                       {yesNo(exam?.oralCavity?.findings, "Buccal Cavity")}
//                     </span>
//                   </div>

//                   <div>
//                     Tongue:
//                     <span
//                       className={getYesNoClass(
//                         yesNo(exam?.oralCavity?.findings, "Tongue"),
//                       )}
//                     >
//                       {yesNo(exam?.oralCavity?.findings, "Tongue")}
//                     </span>
//                   </div>

//                   <div>
//                     Palate:
//                     <span
//                       className={getYesNoClass(
//                         yesNo(exam?.oralCavity?.findings, "Palate"),
//                       )}
//                     >
//                       {yesNo(exam?.oralCavity?.findings, "Palate")}
//                     </span>
//                   </div>

//                   <div>
//                     Lips:
//                     <span
//                       className={getYesNoClass(
//                         yesNo(exam?.oralCavity?.findings, "Lips"),
//                       )}
//                     >
//                       {yesNo(exam?.oralCavity?.findings, "Lips")}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* --- Hair --- */}
//             <div className="finding-card">
//               <div className="card-header">
//                 <h4>Hair</h4>
//               </div>

//               <div className="card-body">
//                 <p>
//                   <span className="date-icon">📅</span>{" "}
//                   <strong>Onset Date:</strong>{" "}
//                   {exam?.hair?.onsetDate?.split("T")[0]}
//                 </p>
//                 <p>
//                   <strong>Findings:</strong>
//                 </p>
//                 <div className="two-column-grid">
//                   <div>
//                     Sparsity of Hair:
//                     <span
//                       className={getYesNoClass(
//                         yesNo(exam?.hair?.findings, "Sparsity"),
//                       )}
//                     >
//                       {yesNo(exam?.hair?.findings, "Sparsity")}
//                     </span>
//                   </div>

//                   <div>
//                     Flaking of Scalp:
//                     <span
//                       className={getYesNoClass(
//                         yesNo(exam?.hair?.findings, "Flaking"),
//                       )}
//                     >
//                       {yesNo(exam?.hair?.findings, "Flaking")}
//                     </span>
//                   </div>

//                   <div>
//                     Hair Colour Lightening:
//                     <span
//                       className={getYesNoClass(
//                         yesNo(exam?.hair?.findings, "Hair Colour Lightening"),
//                       )}
//                     >
//                       {yesNo(exam?.hair?.findings, "Hair Colour Lightening")}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* --- Nails --- */}
//             <div className="finding-card">
//               <div className="card-header">
//                 <h4>Nails</h4>
//               </div>

//               <div className="card-body">
//                 <p>
//                   <span className="date-icon">📅</span>{" "}
//                   <strong>Onset Date:</strong>{" "}
//                   {exam?.nails?.onsetDate?.split("T")[0]}
//                 </p>
//                 <p>
//                   <strong>Findings:</strong>
//                 </p>
//                 <div className="two-column-grid">
//                   <div>
//                     Brittleness:
//                     <span
//                       className={getYesNoClass(
//                         yesNo(exam?.nails?.findings, "Brittleness"),
//                       )}
//                     >
//                       {yesNo(exam?.nails?.findings, "Brittleness")}
//                     </span>
//                   </div>

//                   <div>
//                     Pigmentation:
//                     <span
//                       className={getYesNoClass(
//                         yesNo(exam?.nails?.findings, "Pigmentation"),
//                       )}
//                     >
//                       {yesNo(exam?.nails?.findings, "Pigmentation")}
//                     </span>
//                   </div>

//                   <div>
//                     Swelling Around Nails:
//                     <span
//                       className={getYesNoClass(
//                         yesNo(exam?.nails?.findings, "Swelling Around Nails"),
//                       )}
//                     >
//                       {yesNo(exam?.nails?.findings, "Swelling Around Nails")}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* --- Skin / Cutaneous --- */}
//             <div className="finding-card skin-card">
//               <div className="card-header">
//                 <h4>Skin / Cutaneous</h4>
//               </div>

//               <div className="card-body multi-column">
//                 <div>
//                   <p>
//                     <span className="date-icon">📅</span>{" "}
//                     <strong>Onset Date:</strong>{" "}
//                     {exam?.skinExam?.onsetDate?.split("T")[0]}
//                   </p>

//                   <p>
//                     <strong>Affected Areas:</strong>
//                   </p>

//                   <div className="two-column-grid">
//                     <div>
//                       Face:
//                       <span
//                         className={
//                           exam?.skinExam?.location?.includes("Face")
//                             ? "yes-text"
//                             : "no-text"
//                         }
//                       >
//                         {exam?.skinExam?.location?.includes("Face")
//                           ? "Yes"
//                           : "No"}
//                       </span>
//                     </div>

//                     <div>
//                       Trunk:
//                       <span
//                         className={
//                           exam?.skinExam?.location?.includes("Trunk")
//                             ? "yes-text"
//                             : "no-text"
//                         }
//                       >
//                         {exam?.skinExam?.location?.includes("Trunk")
//                           ? "Yes"
//                           : "No"}
//                       </span>
//                     </div>

//                     <div>
//                       Lower Limbs:
//                       <span
//                         className={
//                           exam?.skinExam?.location?.includes("Lower Limbs")
//                             ? "yes-text"
//                             : "no-text"
//                         }
//                       >
//                         {exam?.skinExam?.location?.includes("Lower Limbs")
//                           ? "Yes"
//                           : "No"}
//                       </span>
//                     </div>

//                     <div>
//                       Upper Limbs:
//                       <span
//                         className={
//                           exam?.skinExam?.location?.includes("Upper Limbs")
//                             ? "yes-text"
//                             : "no-text"
//                         }
//                       >
//                         {exam?.skinExam?.location?.includes("Upper Limbs")
//                           ? "Yes"
//                           : "No"}
//                       </span>
//                     </div>
//                   </div>

//                   {/* ✅ FIXED: Removed textarea → show value */}
//                   <p style={{ marginTop: "8px" }}>
//                     <strong>Others:</strong> {exam?.skinExam?.others || "--"}
//                   </p>
//                 </div>

//                 <div>
//                   <p>
//                     <strong>Clinical Characteristics:</strong>
//                   </p>

//                   {/* ✅ FIXED: Converted to 2-column grid */}
//                   <div className="two-column-grid">
//                     <div>
//                       Elevation:
//                       <span>{exam?.skinExam?.lesion?.elevation || "--"}</span>
//                     </div>

//                     <div>
//                       Size:
//                       <span>{exam?.skinExam?.lesion?.size || "--"}</span>
//                     </div>

//                     <div>
//                       Color:
//                       <span>{exam?.skinExam?.lesion?.colour || "--"}</span>
//                     </div>

//                     <div>
//                       Fluid Filled:
//                       <span
//                         className={
//                           exam?.skinExam?.lesion?.fluidFilled
//                             ? "yes-text"
//                             : "no-text"
//                         }
//                       >
//                         {exam?.skinExam?.lesion?.fluidFilled ? "Yes" : "No"}
//                       </span>
//                     </div>

//                     <div>
//                       Clear Fluid:
//                       <span
//                         className={
//                           exam?.skinExam?.lesion?.clearFluid
//                             ? "yes-text"
//                             : "no-text"
//                         }
//                       >
//                         {exam?.skinExam?.lesion?.clearFluid ? "Yes" : "No"}
//                       </span>
//                     </div>

//                     <div>
//                       Scaly:
//                       <span
//                         className={
//                           exam?.skinExam?.lesion?.scaly ? "yes-text" : "no-text"
//                         }
//                       >
//                         {exam?.skinExam?.lesion?.scaly ? "Yes" : "No"}
//                       </span>
//                     </div>

//                     <div>
//                       Blanching:
//                       <span
//                         className={
//                           exam?.skinExam?.lesion?.blanching
//                             ? "yes-text"
//                             : "no-text"
//                         }
//                       >
//                         {exam?.skinExam?.lesion?.blanching ? "Yes" : "No"}
//                       </span>
//                     </div>

//                     <div>
//                       Epidermal Breakage:
//                       <span
//                         className={
//                           exam?.skinExam?.lesion?.epidermalBreakage
//                             ? "yes-text"
//                             : "no-text"
//                         }
//                       >
//                         {exam?.skinExam?.lesion?.epidermalBreakage
//                           ? "Yes"
//                           : "No"}
//                       </span>
//                     </div>

//                     <div>
//                       Itchy:
//                       <span
//                         className={
//                           exam?.skinExam?.lesion?.itchy ? "yes-text" : "no-text"
//                         }
//                       >
//                         {exam?.skinExam?.lesion?.itchy ? "Yes" : "No"}
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </>
//         )}

//         {/* --- Atopic Dermatitis --- */}

//         {/* {activeSubTab === "ad" && (
//           <div className="finding-card atopic-card">
//             <div className="card-header">
//               <h4>Atopic Dermatitis</h4>
//             </div>

//             <div className="card-body multi-column">
//               <div>
//                 <p>
//                   <strong>IgE Count:</strong>{" "}
//                   <strong className="highlight">
//                     {igeCount !== null ? igeCount : "--"}
//                   </strong>
//                 </p>

//                 <p>
//                   <strong>Major Symptoms:</strong>
//                 </p>

//                 <ul>
//                   <li>
//                     Pruritus:
//                     <span className={hasPruritus ? "yes-text" : "no-text"}>
//                       {hasPruritus === null ? "--" : hasPruritus ? "Yes" : "No"}
//                     </span>
//                   </li>

//                   <li>
//                     Chronic or chronically relapsing:
//                     <span
//                       className={hasChronicRelapsing ? "yes-text" : "no-text"}
//                     >
//                       {hasChronicRelapsing === null
//                         ? "--"
//                         : hasChronicRelapsing
//                           ? "Yes"
//                           : "No"}
//                     </span>
//                   </li>

//                   <li>
//                     Typical Morphology & Distribution:
//                     <span
//                       className={hasTypicalMorphology ? "yes-text" : "no-text"}
//                     >
//                       {hasTypicalMorphology === null
//                         ? "--"
//                         : hasTypicalMorphology
//                           ? "Yes"
//                           : "No"}
//                     </span>
//                   </li>

//                   <li>
//                     Family History of Atopy:
//                     <span className={hasFamilyHistory ? "yes-text" : "no-text"}>
//                       {hasFamilyHistory === null
//                         ? "--"
//                         : hasFamilyHistory
//                           ? "Yes"
//                           : "No"}
//                     </span>
//                   </li>
//                 </ul>
//               </div>

//               <div>
//                 <p>
//                   <strong>Minor Symptoms:</strong>
//                 </p>

//                 <ul>
//                   <li>
//                     Erythema:
//                     <span
//                       className={
//                         minorSymptoms["facial_pallor"] ? "yes-text" : "no-text"
//                       }
//                     >
//                       {minorSymptoms["facial_pallor"] ? "Yes" : "No"}
//                     </span>
//                   </li>

//                   <li>
//                     Pityriasis Alba:
//                     <span
//                       className={
//                         minorSymptoms["pityriasis_alba"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["pityriasis_alba"] ? "Yes" : "No"}
//                     </span>
//                   </li>

//                   <li>
//                     Darkening Around the Eyelids:
//                     <span
//                       className={
//                         minorSymptoms["darkening_around_the_eyelids"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["darkening_around_the_eyelids"]
//                         ? "Yes"
//                         : "No"}
//                     </span>
//                   </li>

//                   <li>
//                     Dennie-Morgan Folds:
//                     <span
//                       className={
//                         minorSymptoms["infra_orbital_folds"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["infra_orbital_folds"] ? "Yes" : "No"}
//                     </span>
//                   </li>

//                   <li>
//                     Cheilitis:
//                     <span
//                       className={
//                         minorSymptoms["dry_lips"] ? "yes-text" : "no-text"
//                       }
//                     >
//                       {minorSymptoms["dry_lips"] ? "Yes" : "No"}
//                     </span>
//                   </li>

//                   <li>
//                     Anterior Neck-Folds:
//                     <span
//                       className={
//                         minorSymptoms["anterior_neck_folds"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["anterior_neck_folds"] ? "Yes" : "No"}
//                     </span>
//                   </li>

//                   <li>
//                     Ichthyosis:
//                     <span
//                       className={
//                         minorSymptoms["ichthyosis"] ? "yes-text" : "no-text"
//                       }
//                     >
//                       {minorSymptoms["ichthyosis"] ? "Yes" : "No"}
//                     </span>
//                   </li>

//                   <li>
//                     Hyper Linear Palms:
//                     <span
//                       className={
//                         minorSymptoms["increased_palmar_lines"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["increased_palmar_lines"] ? "Yes" : "No"}
//                     </span>
//                   </li>

//                   <li>
//                     Hand And Foot Eczema:
//                     <span
//                       className={
//                         minorSymptoms["hand_and_foot_eczema"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["hand_and_foot_eczema"] ? "Yes" : "No"}
//                     </span>
//                   </li>

//                   <li>
//                     Nipple Eczema:
//                     <span
//                       className={
//                         minorSymptoms["nipple_eczema"] ? "yes-text" : "no-text"
//                       }
//                     >
//                       {minorSymptoms["nipple_eczema"] ? "Yes" : "No"}
//                     </span>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         )} */}

//         {/* --- Atopic Dermatitis --- */}

//         {/* {activeSubTab === "ad" && (
//           <div className="finding-card atopic-card">
//             <div className="card-header">
//               <h4>Atopic Dermatitis</h4>
//             </div>

//             <div className="card-body multi-column">
//               <div>
//                 <p>
//                   <strong>IgE Count:</strong>{" "}
//                   <strong className="highlight">
//                     {igeCount !== null ? igeCount : "--"}
//                   </strong>
//                 </p>

//                 <p>
//                   <strong>Major Symptoms:</strong>
//                 </p>

//                 <div className="two-column-grid">
//                   <div>
//                     Pruritus:
//                     <span className={hasPruritus ? "yes-text" : "no-text"}>
//                       {hasPruritus === null ? "--" : hasPruritus ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Chronic Relapsing:
//                     <span
//                       className={hasChronicRelapsing ? "yes-text" : "no-text"}
//                     >
//                       {hasChronicRelapsing === null
//                         ? "--"
//                         : hasChronicRelapsing
//                           ? "Yes"
//                           : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Typical Morphology:
//                     <span
//                       className={hasTypicalMorphology ? "yes-text" : "no-text"}
//                     >
//                       {hasTypicalMorphology === null
//                         ? "--"
//                         : hasTypicalMorphology
//                           ? "Yes"
//                           : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Family History:
//                     <span className={hasFamilyHistory ? "yes-text" : "no-text"}>
//                       {hasFamilyHistory === null
//                         ? "--"
//                         : hasFamilyHistory
//                           ? "Yes"
//                           : "No"}
//                     </span>
//                   </div>
//                 </div>
//               </div>

//               <div>
//                 <p>
//                   <strong>Minor Symptoms:</strong>
//                 </p>

//                 <div className="two-column-grid">
//                   <div>
//                     Erythema:
//                     <span
//                       className={
//                         minorSymptoms["facial_pallor"] ? "yes-text" : "no-text"
//                       }
//                     >
//                       {minorSymptoms["facial_pallor"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Pityriasis Alba:
//                     <span
//                       className={
//                         minorSymptoms["pityriasis_alba"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["pityriasis_alba"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Eyelid Darkening:
//                     <span
//                       className={
//                         minorSymptoms["darkening_around_the_eyelids"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["darkening_around_the_eyelids"]
//                         ? "Yes"
//                         : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Dennie-Morgan Folds:
//                     <span
//                       className={
//                         minorSymptoms["infra_orbital_folds"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["infra_orbital_folds"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Cheilitis:
//                     <span
//                       className={
//                         minorSymptoms["dry_lips"] ? "yes-text" : "no-text"
//                       }
//                     >
//                       {minorSymptoms["dry_lips"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Anterior Neck-Folds:
//                     <span
//                       className={
//                         minorSymptoms["anterior_neck_folds"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["anterior_neck_folds"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Ichthyosis:
//                     <span
//                       className={
//                         minorSymptoms["ichthyosis"] ? "yes-text" : "no-text"
//                       }
//                     >
//                       {minorSymptoms["ichthyosis"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Hyper Linear Palms:
//                     <span
//                       className={
//                         minorSymptoms["increased_palmar_lines"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["increased_palmar_lines"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Hand & Foot Eczema:
//                     <span
//                       className={
//                         minorSymptoms["hand_and_foot_eczema"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["hand_and_foot_eczema"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Nipple Eczema:
//                     <span
//                       className={
//                         minorSymptoms["nipple_eczema"] ? "yes-text" : "no-text"
//                       }
//                     >
//                       {minorSymptoms["nipple_eczema"] ? "Yes" : "No"}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )} */}

//         {/* --- Atopic Dermatitis --- */}

//         {/* {activeSubTab === "ad" && ( */}
//         {props.showADTab && activeSubTab === "ad" && (
//           <div className="finding-card atopic-card">
//             <div className="card-header">
//               <h4>Atopic Dermatitis</h4>
//             </div>

//             <div className="card-body multi-column">
//               {/* LEFT SIDE */}
//               <div>
//                 <p>
//                   <strong>IgE Count:</strong>{" "}
//                   <strong className="highlight">
//                     {igeCount !== null ? igeCount : "--"}
//                   </strong>
//                 </p>

//                 {/* ✅ NEW FIELD ADDED */}
//                 <p>
//                   <strong>Allergic Rhinitis Risk:</strong>{" "}
//                   {/* <span className="no-text">
//                     {hasAnyYes([
//                       hasPruritus,
//                       hasChronicRelapsing,
//                       hasTypicalMorphology,
//                       hasFamilyHistory,
//                     ])
//                       ? "Yes"
//                       : "No"}
//                   </span> */}

//                   {/* //static answer for testing   */}
//                   {/* <span className="yes-text">Yes</span> */}
//                   <span className={hasPruritus ? "yes-text" : "no-text"}>
//   {hasPruritus ? "Yes" : "No"}
// </span>
//                 </p>

//                 <p>
//                   <strong>Major Symptoms:</strong>
//                 </p>

//                 <div className="two-column-grid">
//                   <div>
//                     Pruritus:
//                     <span className={hasPruritus ? "yes-text" : "no-text"}>
//                       {hasPruritus === null ? "--" : hasPruritus ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Chronic Relapsing:
//                     <span
//                       className={hasChronicRelapsing ? "yes-text" : "no-text"}
//                     >
//                       {hasChronicRelapsing === null
//                         ? "--"
//                         : hasChronicRelapsing
//                           ? "Yes"
//                           : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Typical Morphology:
//                     <span
//                       className={hasTypicalMorphology ? "yes-text" : "no-text"}
//                     >
//                       {hasTypicalMorphology === null
//                         ? "--"
//                         : hasTypicalMorphology
//                           ? "Yes"
//                           : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Family History:
//                     <span className={hasFamilyHistory ? "yes-text" : "no-text"}>
//                       {hasFamilyHistory === null
//                         ? "--"
//                         : hasFamilyHistory
//                           ? "Yes"
//                           : "No"}
//                     </span>
//                   </div>
//                 </div>
//               </div>

//               {/* RIGHT SIDE */}
//               <div>
//                 <p>
//                   <strong>Minor Symptoms:</strong>
//                 </p>

//                 <div className="two-column-grid">
//                   <div>
//                     Erythema:
//                     <span
//                       className={
//                         minorSymptoms["facial_pallor"] ? "yes-text" : "no-text"
//                       }
//                     >
//                       {minorSymptoms["facial_pallor"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Pityriasis Alba:
//                     <span
//                       className={
//                         minorSymptoms["pityriasis_alba"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["pityriasis_alba"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Eyelid Darkening:
//                     <span
//                       className={
//                         minorSymptoms["darkening_around_the_eyelids"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["darkening_around_the_eyelids"]
//                         ? "Yes"
//                         : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Dennie-Morgan Folds:
//                     <span
//                       className={
//                         minorSymptoms["infra_orbital_folds"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["infra_orbital_folds"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Cheilitis:
//                     <span
//                       className={
//                         minorSymptoms["dry_lips"] ? "yes-text" : "no-text"
//                       }
//                     >
//                       {minorSymptoms["dry_lips"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Anterior Neck-Folds:
//                     <span
//                       className={
//                         minorSymptoms["anterior_neck_folds"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["anterior_neck_folds"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Ichthyosis:
//                     <span
//                       className={
//                         minorSymptoms["ichthyosis"] ? "yes-text" : "no-text"
//                       }
//                     >
//                       {minorSymptoms["ichthyosis"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Hyper Linear Palms:
//                     <span
//                       className={
//                         minorSymptoms["increased_palmar_lines"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["increased_palmar_lines"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Hand & Foot Eczema:
//                     <span
//                       className={
//                         minorSymptoms["hand_and_foot_eczema"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["hand_and_foot_eczema"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Nipple Eczema:
//                     <span
//                       className={
//                         minorSymptoms["nipple_eczema"] ? "yes-text" : "no-text"
//                       }
//                     >
//                       {minorSymptoms["nipple_eczema"] ? "Yes" : "No"}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default DermSummaryTab;


// src/components/dermatology/DermSummaryTab.tsx
// import React, { useEffect, useState } from "react";
// import "../../css/DermSummaryTab.css";
// import DermReportSection from "./DermReportSection";
// import api from "../../api/axiosConfig";
// import { ReportRecommendations } from "../../pages/DermatologyScreen";

// interface DermTabProps {
//   emrId: string;
//   patientAge: number;
//   doctorName: string;
//   userId: string;
//   activeSubTab?: "derma" | "ad";
//   telePrognosis: string;
//   setTelePrognosis: (value: string) => void;
//   medicalAdvice: string;
//   setMedicalAdvice: (value: string) => void;
//   recommendations: ReportRecommendations;
//   setRecommendations: (recommendations: ReportRecommendations) => void;
//   onSubmitSuccess?: () => void;
//   showADTab?: boolean;
// }

// const DermSummaryTab: React.FC<DermTabProps> = (props) => {
//   const [exam, setExam] = useState<any>(null);
//   const [hasPruritus, setHasPruritus] = useState<boolean | null>(null);
//   const [hasChronicRelapsing, setHasChronicRelapsing] = useState<boolean | null>(null);
//   const [hasTypicalMorphology, setHasTypicalMorphology] = useState<boolean | null>(null);
//   const [hasFamilyHistory, setHasFamilyHistory] = useState<boolean | null>(null);
//   const [minorSymptoms, setMinorSymptoms] = useState<Record<string, boolean>>({});
//   const [igeCount, setIgeCount] = useState<number | null>(null);

//   const activeSubTab = props.activeSubTab || "derma";

//   const getYesNoClass = (value: string) => {
//     if (value === "Yes") return "yes-text";
//     if (value === "No") return "no-text";
//     return "";
//   };

//   // 🔥 Main Fetch Block (Dynamic EMR for both exam and health score)
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const currentEmr = props.emrId;

//         if (!currentEmr) return;

//         // 1. Dynamic EMR for physical exam
//         const examRes = await api.dataCollectionApi.get(
//           `/api/forms/physical-exam/${currentEmr}`
//         );
//         setExam(examRes?.data?.data);

//         // 2. Dynamic EMR for health scores
//         const healthRes = await api.Questionnair.get(
//           `/api/scoring/scoresId/${currentEmr}/health`
//         );

//         const results = healthRes?.data?.scores?.resultsById || {};
//         const adAnswer = String(results["1220"] || "").toLowerCase();

//         setHasChronicRelapsing(adAnswer === "yes" || adAnswer === "maybe");
//         setHasPruritus(adAnswer === "yes" || adAnswer === "maybe");
//         setHasTypicalMorphology(adAnswer === "yes" || adAnswer === "maybe");
//         setHasFamilyHistory(adAnswer === "yes" || adAnswer === "maybe");

//       } catch (err) {
//         console.error("Failed to fetch dermatology summary data", err);
//       }
//     };

//     fetchData();
//   }, [props.emrId]);

//   const yesNo = (arr: string[] | undefined, key: string) =>
//     arr?.includes(key) ? "Yes" : "No";

//   // 🔥 Dynamic symptom checker
//   const hasAnyYes = (values: (boolean | undefined | null)[]) =>
//     values.some((v) => v === true);

//   const hasAnyFromArray = (arr: string[] | undefined) =>
//     Array.isArray(arr) && arr.length > 0;

//   // 🔥 Separate Minor Symptoms API
//   useEffect(() => {
//     const fetchMinorSymptoms = async () => {
//       try {
//         const response = await api.dataCollectionApi.get(
//           `/api/forms/atopic-dermatitis/${props.emrId}`
//         );

//         const features = response?.data?.data?.features || [];
//         const featureMap: Record<string, boolean> = {};

//         features.forEach((feature: any) => {
//           featureMap[feature.code] = feature.observed === true;
//         });

//         setMinorSymptoms(featureMap);
//       } catch (error) {
//         console.error("Failed to fetch minor symptoms", error);
//       }
//     };

//     fetchMinorSymptoms();
//   }, [props.emrId]);

//   // 🔥 Separate IgE Count API
//   useEffect(() => {
//     const fetchIgeCount = async () => {
//       try {
//         const response = await api.dataCollectionApi.get(
//           `/api/forms/lab-report/${props.emrId}`
//         );

//         const igeValue =
//           response?.data?.data?.["Immunoglobulin E (Total IgE)"]?.["Immunoglobulin E"] ?? null;

//         setIgeCount(igeValue);
//       } catch (error) {
//         console.error("Failed to fetch IgE count", error);
//         setIgeCount(null);
//       }
//     };

//     fetchIgeCount();
//   }, [props.emrId]);

//   // 🔥 Submit Dermatology Report
//   const handleSubmitReport = async () => {
//     if (!props.telePrognosis.trim()) {
//       alert("Please enter Tele-Prognosis");
//       return;
//     }

//     if (!props.medicalAdvice.trim()) {
//       alert("Please enter Medical Advice");
//       return;
//     }

//     const selectedRecommendations = Object.entries(props.recommendations)
//       .filter(([_, value]) => value === true)
//       .map(([key]) => key);

//     if (selectedRecommendations.length === 0) {
//       alert("Please select at least one Recommendation");
//       return;
//     }

//     try {
//       const payload = {
//         emrId: props.emrId,
//         chartType: "primary",
//         age: props.patientAge,
//         doctorName: props.doctorName,
//         reportWriting: {
//           telePrognosis: props.telePrognosis,
//           medicalAdvice: props.medicalAdvice,
//           recommendations: selectedRecommendations,
//         },
//         createdBy: "doctor_user",
//       };

//       const response = await api.dataCollectionApi.post(
//         "/teledocs/dermatology/report/submit",
//         payload
//       );

//       console.log("Report Submitted Successfully:", response.data);

//       handleResetReport();

//       if (props.onSubmitSuccess) {
//         props.onSubmitSuccess();
//       }
//     } catch (error) {
//       console.error("Failed to submit report", error);
//       alert("Failed to submit report");
//     }
//   };

//   const handleResetReport = () => {
//     props.setTelePrognosis("");
//     props.setMedicalAdvice("");

//     props.setRecommendations({
//       none: false,
//       followAdvice: false,
//       consultDerm: false,
//     });
//   };

//   return (
//     <div className="derm-summary-container">
//       <h3 className="summary-title">Findings Overview</h3>

//       <div className="findings-grid">
//         {/* ===== DERMA SYMPTOMS ===== */}
//         {activeSubTab === "derma" && (
//           <>
//             {/* --- Oral Cavity --- */}
//             <div className="finding-card">
//               <div className="card-header">
//                 <h4>Oral Cavity</h4>
//               </div>

//               <div className="card-body">
//                 <p>
//                   <span className="date-icon">📅</span>{" "}
//                   <strong>Onset Date:</strong>{" "}
//                   {exam?.oralCavity?.onsetDate?.split("T")[0] || "--"}
//                 </p>
//                 <p>
//                   <strong>Location:</strong>
//                 </p>
//                 <div className="two-column-grid">
//                   <div>
//                     Buccal Cavity:
//                     <span
//                       className={getYesNoClass(
//                         yesNo(exam?.oralCavity?.findings, "Buccal Cavity")
//                       )}
//                     >
//                       {yesNo(exam?.oralCavity?.findings, "Buccal Cavity")}
//                     </span>
//                   </div>

//                   <div>
//                     Tongue:
//                     <span
//                       className={getYesNoClass(
//                         yesNo(exam?.oralCavity?.findings, "Tongue")
//                       )}
//                     >
//                       {yesNo(exam?.oralCavity?.findings, "Tongue")}
//                     </span>
//                   </div>

//                   <div>
//                     Palate:
//                     <span
//                       className={getYesNoClass(
//                         yesNo(exam?.oralCavity?.findings, "Palate")
//                       )}
//                     >
//                       {yesNo(exam?.oralCavity?.findings, "Palate")}
//                     </span>
//                   </div>

//                   <div>
//                     Lips:
//                     <span
//                       className={getYesNoClass(
//                         yesNo(exam?.oralCavity?.findings, "Lips")
//                       )}
//                     >
//                       {yesNo(exam?.oralCavity?.findings, "Lips")}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* --- Hair --- */}
//             <div className="finding-card">
//               <div className="card-header">
//                 <h4>Hair</h4>
//               </div>

//               <div className="card-body">
//                 <p>
//                   <span className="date-icon">📅</span>{" "}
//                   <strong>Onset Date:</strong>{" "}
//                   {exam?.hair?.onsetDate?.split("T")[0] || "--"}
//                 </p>
//                 <p>
//                   <strong>Findings:</strong>
//                 </p>
//                 <div className="two-column-grid">
//                   <div>
//                     Sparsity of Hair:
//                     <span
//                       className={getYesNoClass(
//                         yesNo(exam?.hair?.findings, "Sparsity")
//                       )}
//                     >
//                       {yesNo(exam?.hair?.findings, "Sparsity")}
//                     </span>
//                   </div>

//                   <div>
//                     Flaking of Scalp:
//                     <span
//                       className={getYesNoClass(
//                         yesNo(exam?.hair?.findings, "Flaking")
//                       )}
//                     >
//                       {yesNo(exam?.hair?.findings, "Flaking")}
//                     </span>
//                   </div>

//                   <div>
//                     Hair Colour Lightening:
//                     <span
//                       className={getYesNoClass(
//                         yesNo(exam?.hair?.findings, "Hair Colour Lightening")
//                       )}
//                     >
//                       {yesNo(exam?.hair?.findings, "Hair Colour Lightening")}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* --- Nails --- */}
//             <div className="finding-card">
//               <div className="card-header">
//                 <h4>Nails</h4>
//               </div>

//               <div className="card-body">
//                 <p>
//                   <span className="date-icon">📅</span>{" "}
//                   <strong>Onset Date:</strong>{" "}
//                   {exam?.nails?.onsetDate?.split("T")[0] || "--"}
//                 </p>
//                 <p>
//                   <strong>Findings:</strong>
//                 </p>
//                 <div className="two-column-grid">
//                   <div>
//                     Brittleness:
//                     <span
//                       className={getYesNoClass(
//                         yesNo(exam?.nails?.findings, "Brittleness")
//                       )}
//                     >
//                       {yesNo(exam?.nails?.findings, "Brittleness")}
//                     </span>
//                   </div>

//                   <div>
//                     Pigmentation:
//                     <span
//                       className={getYesNoClass(
//                         yesNo(exam?.nails?.findings, "Pigmentation")
//                       )}
//                     >
//                       {yesNo(exam?.nails?.findings, "Pigmentation")}
//                     </span>
//                   </div>

//                   <div>
//                     Swelling Around Nails:
//                     <span
//                       className={getYesNoClass(
//                         yesNo(exam?.nails?.findings, "Swelling Around Nails")
//                       )}
//                     >
//                       {yesNo(exam?.nails?.findings, "Swelling Around Nails")}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* --- Skin / Cutaneous --- */}
//             <div className="finding-card skin-card">
//               <div className="card-header">
//                 <h4>Skin / Cutaneous</h4>
//               </div>

//               <div className="card-body">
//                 {/* Loop through the 4 specific areas using the exact new backend keys */}
//                 {[
//                   { label: "Face", key: "face" as const },
//                   { label: "Upper Limbs", key: "upperLimb" as const },
//                   { label: "Lower Limbs", key: "lowerLimb" as const },
//                   { label: "Trunk", key: "trunk" as const }
//                 ].map((region) => {
                  
//                   // Access the independent data for this specific region
//                   const regionData = exam?.skinExam?.[region.key];
//                   const isAffected = regionData?.selected === true;
//                   const lesion = regionData?.lesion;

//                   return (
//                     <div key={region.key} className="area-section" style={{ marginBottom: "24px", paddingBottom: "16px", borderBottom: "1px solid #eee" }}>
                      
//                       {/* Area Header (Yes/No) */}
//                       <div style={{ display: "flex", gap: "12px", alignItems: "center", marginBottom: "8px" }}>
//                         <strong style={{ minWidth: "120px" }}>{region.label}:</strong>
//                         <span className={isAffected ? "yes-text" : "no-text"}>
//                           {isAffected ? "Yes" : "No"}
//                         </span>
//                       </div>

//                       {/* Always show characteristics structure, regardless of whether it is affected */}
//                       <div style={{ paddingLeft: "16px", borderLeft: "3px solid #e0e0e0", marginLeft: "8px" }}>
                        
//                         {/* Each region now has its own Onset Date */}
//                         <p style={{ marginBottom: "8px" }}>
//                           <span className="date-icon">📅</span>{" "}
//                           <strong>Onset Date:</strong>{" "}
//                           {regionData?.onsetDate ? regionData.onsetDate.split("T")[0] : "--"}
//                         </p>
                        
//                         {/* Each region now has its own Findings */}
//                         <p style={{ marginBottom: "12px" }}>
//                           <strong>Findings:</strong> {regionData?.findings?.length > 0 ? regionData.findings.join(", ") : "--"}
//                         </p>

//                         <p style={{ marginBottom: "8px" }}><strong>Clinical Characteristics:</strong></p>
//                         <div className="two-column-grid">
//                           <div>
//                             Elevation:
//                             <span>{lesion?.elevation || "--"}</span>
//                           </div>

//                           <div>
//                             Size:
//                             <span>{lesion?.size || "--"}</span>
//                           </div>

//                           <div>
//                             Color:
//                             <span>{lesion?.colour || "--"}</span>
//                           </div>

//                           <div>
//                             Fluid Filled:
//                             <span className={lesion?.fluidFilled ? "yes-text" : "no-text"}>
//                               {lesion?.fluidFilled ? "Yes" : "No"}
//                             </span>
//                           </div>

//                           <div>
//                             Clear Fluid:
//                             <span className={lesion?.clearFluid ? "yes-text" : "no-text"}>
//                               {lesion?.clearFluid ? "Yes" : "No"}
//                             </span>
//                           </div>

//                           <div>
//                             Scaly:
//                             <span className={lesion?.scaly ? "yes-text" : "no-text"}>
//                               {lesion?.scaly ? "Yes" : "No"}
//                             </span>
//                           </div>

//                           <div>
//                             Blanching:
//                             <span className={lesion?.blanching ? "yes-text" : "no-text"}>
//                               {lesion?.blanching ? "Yes" : "No"}
//                             </span>
//                           </div>

//                           <div>
//                             Epidermal Breakage:
//                             <span className={lesion?.epidermalBreakage ? "yes-text" : "no-text"}>
//                               {lesion?.epidermalBreakage ? "Yes" : "No"}
//                             </span>
//                           </div>

//                           <div>
//                             Itchy:
//                             <span className={lesion?.itchy ? "yes-text" : "no-text"}>
//                               {lesion?.itchy ? "Yes" : "No"}
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </>
//         )}

//         {/* --- Atopic Dermatitis --- */}
//         {props.showADTab && activeSubTab === "ad" && (
//           <div className="finding-card atopic-card">
//             <div className="card-header">
//               <h4>Atopic Dermatitis</h4>
//             </div>

//             <div className="card-body multi-column">
//               {/* LEFT SIDE */}
//               <div>
//                 <p>
//                   <strong>IgE Count:</strong>{" "}
//                   <strong className="highlight">
//                     {igeCount !== null ? igeCount : "--"}
//                   </strong>
//                 </p>

//                 <p>
//                   <strong>Allergic Rhinitis Risk:</strong>{" "}
//                   <span className={hasPruritus ? "yes-text" : "no-text"}>
//                     {hasPruritus ? "Yes" : "No"}
//                   </span>
//                 </p>

//                 <p>
//                   <strong>Major Symptoms:</strong>
//                 </p>

//                 <div className="two-column-grid">
//                   <div>
//                     Pruritus:
//                     <span className={hasPruritus ? "yes-text" : "no-text"}>
//                       {hasPruritus === null ? "--" : hasPruritus ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Chronic Relapsing:
//                     <span
//                       className={hasChronicRelapsing ? "yes-text" : "no-text"}
//                     >
//                       {hasChronicRelapsing === null
//                         ? "--"
//                         : hasChronicRelapsing
//                           ? "Yes"
//                           : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Typical Morphology:
//                     <span
//                       className={hasTypicalMorphology ? "yes-text" : "no-text"}
//                     >
//                       {hasTypicalMorphology === null
//                         ? "--"
//                         : hasTypicalMorphology
//                           ? "Yes"
//                           : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Family History:
//                     <span className={hasFamilyHistory ? "yes-text" : "no-text"}>
//                       {hasFamilyHistory === null
//                         ? "--"
//                         : hasFamilyHistory
//                           ? "Yes"
//                           : "No"}
//                     </span>
//                   </div>
//                 </div>
//               </div>

//               {/* RIGHT SIDE */}
//               <div>
//                 <p>
//                   <strong>Minor Symptoms:</strong>
//                 </p>

//                 <div className="two-column-grid">
//                   <div>
//                     Erythema:
//                     <span
//                       className={
//                         minorSymptoms["facial_pallor"] ? "yes-text" : "no-text"
//                       }
//                     >
//                       {minorSymptoms["facial_pallor"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Pityriasis Alba:
//                     <span
//                       className={
//                         minorSymptoms["pityriasis_alba"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["pityriasis_alba"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Eyelid Darkening:
//                     <span
//                       className={
//                         minorSymptoms["darkening_around_the_eyelids"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["darkening_around_the_eyelids"]
//                         ? "Yes"
//                         : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Dennie-Morgan Folds:
//                     <span
//                       className={
//                         minorSymptoms["infra_orbital_folds"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["infra_orbital_folds"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Cheilitis:
//                     <span
//                       className={
//                         minorSymptoms["dry_lips"] ? "yes-text" : "no-text"
//                       }
//                     >
//                       {minorSymptoms["dry_lips"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Anterior Neck-Folds:
//                     <span
//                       className={
//                         minorSymptoms["anterior_neck_folds"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["anterior_neck_folds"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Ichthyosis:
//                     <span
//                       className={
//                         minorSymptoms["ichthyosis"] ? "yes-text" : "no-text"
//                       }
//                     >
//                       {minorSymptoms["ichthyosis"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Hyper Linear Palms:
//                     <span
//                       className={
//                         minorSymptoms["increased_palmar_lines"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["increased_palmar_lines"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Hand & Foot Eczema:
//                     <span
//                       className={
//                         minorSymptoms["hand_and_foot_eczema"]
//                           ? "yes-text"
//                           : "no-text"
//                       }
//                     >
//                       {minorSymptoms["hand_and_foot_eczema"] ? "Yes" : "No"}
//                     </span>
//                   </div>

//                   <div>
//                     Nipple Eczema:
//                     <span
//                       className={
//                         minorSymptoms["nipple_eczema"] ? "yes-text" : "no-text"
//                       }
//                     >
//                       {minorSymptoms["nipple_eczema"] ? "Yes" : "No"}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default DermSummaryTab;






// src/components/dermatology/DermSummaryTab.tsx
import React, { useEffect, useState } from "react";
import "../../css/DermSummaryTab.css";
import DermReportSection from "./DermReportSection";
import api from "../../api/axiosConfig";
import { ReportRecommendations } from "../../pages/DermatologyScreen";

interface DermTabProps {
  emrId: string;
  patientAge: number;
  doctorName: string;
  userId: string;
  activeSubTab?: "derma" | "ad";
  telePrognosis: string;
  setTelePrognosis: (value: string) => void;
  medicalAdvice: string;
  setMedicalAdvice: (value: string) => void;
  recommendations: ReportRecommendations;
  setRecommendations: (recommendations: ReportRecommendations) => void;
  onSubmitSuccess?: () => void;
  showADTab?: boolean;
}

const DermSummaryTab: React.FC<DermTabProps> = (props) => {
  const [exam, setExam] = useState<any>(null);
  const [hasPruritus, setHasPruritus] = useState<boolean | null>(null);
  const [hasChronicRelapsing, setHasChronicRelapsing] = useState<boolean | null>(null);
  const [hasTypicalMorphology, setHasTypicalMorphology] = useState<boolean | null>(null);
  const [hasFamilyHistory, setHasFamilyHistory] = useState<boolean | null>(null);
  const [minorSymptoms, setMinorSymptoms] = useState<Record<string, boolean>>({});
  const [igeCount, setIgeCount] = useState<number | null>(null);

  const activeSubTab = props.activeSubTab || "derma";

  const getYesNoClass = (value: string) => {
    if (value === "Yes") return "yes-text";
    if (value === "No") return "no-text";
    return "";
  };

  // 🔥 Safely check arrays from the DB
  const yesNo = (arr: string[] | undefined, key: string) =>
    Array.isArray(arr) && arr.includes(key) ? "Yes" : "No";

  // 🔥 Safely render booleans from the DB
  const renderBool = (val: boolean | undefined | null) => 
    val === true ? "Yes" : "No";

  // =========================================================
  // API Calls
  // =========================================================

  useEffect(() => {
    const fetchData = async () => {
      try {
        const currentEmr = props.emrId;
        if (!currentEmr) return;

        // 1. Dynamic EMR for physical exam
        const examRes = await api.dataCollectionApi.get(
          `/api/forms/physical-exam/${currentEmr}`
        );
        setExam(examRes?.data?.data);

        // 2. Dynamic EMR for health scores
        const healthRes = await api.Questionnair.get(
          `/api/scoring/scoresId/${currentEmr}/health`
        );

        const results = healthRes?.data?.scores?.resultsById || {};
        const adAnswer = String(results["1220"] || "").toLowerCase();

        setHasChronicRelapsing(adAnswer === "yes" || adAnswer === "maybe");
        setHasPruritus(adAnswer === "yes" || adAnswer === "maybe");
        setHasTypicalMorphology(adAnswer === "yes" || adAnswer === "maybe");
        setHasFamilyHistory(adAnswer === "yes" || adAnswer === "maybe");

      } catch (err) {
        console.error("Failed to fetch dermatology summary data", err);
      }
    };
    fetchData();
  }, [props.emrId]);

  useEffect(() => {
    const fetchMinorSymptoms = async () => {
      try {
        const response = await api.dataCollectionApi.get(
          `/api/forms/atopic-dermatitis/${props.emrId}`
        );

        const features = response?.data?.data?.features || [];
        const featureMap: Record<string, boolean> = {};

        features.forEach((feature: any) => {
          featureMap[feature.code] = feature.observed === true;
        });

        setMinorSymptoms(featureMap);
      } catch (error) {
        console.error("Failed to fetch minor symptoms", error);
      }
    };
    fetchMinorSymptoms();
  }, [props.emrId]);

  useEffect(() => {
    const fetchIgeCount = async () => {
      try {
        const response = await api.dataCollectionApi.get(
          `/api/forms/lab-report/${props.emrId}`
        );

        const igeValue =
          response?.data?.data?.["Immunoglobulin E (Total IgE)"]?.["Immunoglobulin E"] ?? null;

        setIgeCount(igeValue);
      } catch (error) {
        console.error("Failed to fetch IgE count", error);
        setIgeCount(null);
      }
    };
    fetchIgeCount();
  }, [props.emrId]);

  const handleSubmitReport = async () => {
    if (!props.telePrognosis.trim()) {
      alert("Please enter Tele-Prognosis");
      return;
    }

    if (!props.medicalAdvice.trim()) {
      alert("Please enter Medical Advice");
      return;
    }

    const selectedRecommendations = Object.entries(props.recommendations)
      .filter(([_, value]) => value === true)
      .map(([key]) => key);

    if (selectedRecommendations.length === 0) {
      alert("Please select at least one Recommendation");
      return;
    }

    try {
      const payload = {
        emrId: props.emrId,
        chartType: "primary",
        age: props.patientAge,
        doctorName: props.doctorName,
        reportWriting: {
          telePrognosis: props.telePrognosis,
          medicalAdvice: props.medicalAdvice,
          recommendations: selectedRecommendations,
        },
        createdBy: "doctor_user",
      };

      const response = await api.dataCollectionApi.post(
        "/teledocs/dermatology/report/submit",
        payload
      );

      console.log("Report Submitted Successfully:", response.data);
      handleResetReport();

      if (props.onSubmitSuccess) {
        props.onSubmitSuccess();
      }
    } catch (error) {
      console.error("Failed to submit report", error);
      alert("Failed to submit report");
    }
  };

  const handleResetReport = () => {
    props.setTelePrognosis("");
    props.setMedicalAdvice("");
    props.setRecommendations({
      none: false,
      followAdvice: false,
      consultDerm: false,
    });
  };

  return (
    <div className="derm-summary-container">
      <h3 className="summary-title">Findings Overview</h3>

      <div className="findings-grid">
        {/* ===== DERMA SYMPTOMS ===== */}
        {activeSubTab === "derma" && (
          <>
            {/* --- Oral Cavity --- */}
            <div className="finding-card">
              <div className="card-header">
                <h4>Oral Cavity</h4>
              </div>
              <div className="card-body">
                <p>
                  <span className="date-icon">📅</span>{" "}
                  <strong>Onset Date:</strong>{" "}
                  {exam?.oralCavity?.onsetDate?.split("T")[0] || "--"}
                </p>
                <p><strong>Location:</strong></p>
                <div className="two-column-grid">
                  <div>
                    Buccal Cavity:{" "}
                    <span className={getYesNoClass(yesNo(exam?.oralCavity?.findings, "Buccal Cavity"))}>
                      {yesNo(exam?.oralCavity?.findings, "Buccal Cavity")}
                    </span>
                  </div>
                  <div>
                    Tongue:{" "}
                    <span className={getYesNoClass(yesNo(exam?.oralCavity?.findings, "Tongue"))}>
                      {yesNo(exam?.oralCavity?.findings, "Tongue")}
                    </span>
                  </div>
                  <div>
                    Palate:{" "}
                    <span className={getYesNoClass(yesNo(exam?.oralCavity?.findings, "Palate"))}>
                      {yesNo(exam?.oralCavity?.findings, "Palate")}
                    </span>
                  </div>
                  <div>
                    Lips:{" "}
                    <span className={getYesNoClass(yesNo(exam?.oralCavity?.findings, "Lips"))}>
                      {yesNo(exam?.oralCavity?.findings, "Lips")}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* --- Hair --- */}
            <div className="finding-card">
              <div className="card-header">
                <h4>Hair</h4>
              </div>
              <div className="card-body">
                <p>
                  <span className="date-icon">📅</span>{" "}
                  <strong>Onset Date:</strong>{" "}
                  {exam?.hair?.onsetDate?.split("T")[0] || "--"}
                </p>
                <p><strong>Findings:</strong></p>
                <div className="two-column-grid">
                  <div>
                    Sparsity of Hair:{" "}
                    <span className={getYesNoClass(yesNo(exam?.hair?.findings, "Sparsity"))}>
                      {yesNo(exam?.hair?.findings, "Sparsity")}
                    </span>
                  </div>
                  <div>
                    Flaking of Scalp:{" "}
                    <span className={getYesNoClass(yesNo(exam?.hair?.findings, "Flaking"))}>
                      {yesNo(exam?.hair?.findings, "Flaking")}
                    </span>
                  </div>
                  <div>
                    Hair Colour Lightening:{" "}
                    <span className={getYesNoClass(yesNo(exam?.hair?.findings, "Hair Colour Lightening"))}>
                      {yesNo(exam?.hair?.findings, "Hair Colour Lightening")}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* --- Nails --- */}
            <div className="finding-card">
              <div className="card-header">
                <h4>Nails</h4>
              </div>
              <div className="card-body">
                <p>
                  <span className="date-icon">📅</span>{" "}
                  <strong>Onset Date:</strong>{" "}
                  {exam?.nails?.onsetDate?.split("T")[0] || "--"}
                </p>
                <p><strong>Findings:</strong></p>
                <div className="two-column-grid">
                  <div>
                    Brittleness:{" "}
                    <span className={getYesNoClass(yesNo(exam?.nails?.findings, "Brittleness"))}>
                      {yesNo(exam?.nails?.findings, "Brittleness")}
                    </span>
                  </div>
                  <div>
                    Pigmentation:{" "}
                    <span className={getYesNoClass(yesNo(exam?.nails?.findings, "Pigmentation"))}>
                      {yesNo(exam?.nails?.findings, "Pigmentation")}
                    </span>
                  </div>
                  <div>
                    Swelling Around Nails:{" "}
                    <span className={getYesNoClass(yesNo(exam?.nails?.findings, "Swelling Around Nails"))}>
                      {yesNo(exam?.nails?.findings, "Swelling Around Nails")}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* --- Skin / Cutaneous --- */}
            <div className="finding-card skin-card" style={{ gridColumn: "1 / -1" }}>
              <div className="card-header">
                <h4>Skin / Cutaneous</h4>
              </div>
              <div className="card-body">
                {[
                  { label: "Face", searchStr: "Face", key: "face" as const },
                  { label: "Upper Limbs", searchStr: "Upper Limbs", key: "upperLimb" as const },
                  { label: "Lower Limbs", searchStr: "Lower Limbs", key: "lowerLimb" as const },
                  { label: "Trunk", searchStr: "Trunk", key: "trunk" as const }
                ].map((region) => {
                  
                  // 1. Check for nested object (New Schema)
                  const nestedData = exam?.skinExam?.[region.key];
                  
                  // 2. Check for flat comma-separated string (Legacy/Current DB Data)
                  const flatLocationStr = typeof exam?.skinExam?.location === 'string' 
                    ? exam?.skinExam?.location 
                    : "";
                  
                  // Determine if this area is affected based on EITHER data structure
                  const isAffected = nestedData?.selected === true || flatLocationStr.includes(region.searchStr);

                  // Extract data, falling back to the root `skinExam` if using the flat structure
                  const rawOnsetDate = nestedData?.onsetDate || (isAffected ? exam?.skinExam?.onsetDate : null);
                  const displayDate = rawOnsetDate ? rawOnsetDate.split("T")[0] : "--";

                  const findingsArr = nestedData?.findings || (isAffected ? exam?.skinExam?.findings : []);
                  const findingsStr = Array.isArray(findingsArr) && findingsArr.length > 0 ? findingsArr.join(", ") : "--";

                  const lesion = nestedData?.lesion || (isAffected ? exam?.skinExam?.lesion : null);

                  return (
                    <div key={region.key} className="area-section" style={{ marginBottom: "24px", paddingBottom: "16px", borderBottom: "1px solid #eee" }}>
                      
                      {/* Area Header (Yes/No) */}
                      <div style={{ display: "flex", gap: "12px", alignItems: "center", marginBottom: "8px" }}>
                        <strong style={{ minWidth: "120px" }}>{region.label}:</strong>
                        <span className={isAffected ? "yes-text" : "no-text"}>
                          {isAffected ? "Yes" : "No"}
                        </span>
                      </div>

                      {/* Details Section */}
                      <div style={{ paddingLeft: "16px", borderLeft: "3px solid #e0e0e0", marginLeft: "8px" }}>
                        <p style={{ marginBottom: "8px" }}>
                          <span className="date-icon">📅</span>{" "}
                          <strong>Onset Date:</strong> {displayDate}
                        </p>

                        <p style={{ marginBottom: "12px" }}>
                          <strong>Findings:</strong> {findingsStr}
                        </p>

                        <p style={{ marginBottom: "8px" }}><strong>Clinical Characteristics:</strong></p>
                        <div className="two-column-grid">
                          <div>
                            Elevation: <span>{lesion?.elevation || "--"}</span>
                          </div>
                          <div>
                            Size: <span>{lesion?.size || "--"}</span>
                          </div>
                          <div>
                            Color: <span>{lesion?.colour || "--"}</span>
                          </div>
                          
                          {/* Map Booleans using renderBool */}
                          <div>
                            Fluid Filled:{" "}
                            <span className={getYesNoClass(renderBool(lesion?.fluidFilled))}>
                              {renderBool(lesion?.fluidFilled)}
                            </span>
                          </div>
                          <div>
                            Clear Fluid:{" "}
                            <span className={getYesNoClass(renderBool(lesion?.clearFluid))}>
                              {renderBool(lesion?.clearFluid)}
                            </span>
                          </div>
                          <div>
                            Scaly:{" "}
                            <span className={getYesNoClass(renderBool(lesion?.scaly))}>
                              {renderBool(lesion?.scaly)}
                            </span>
                          </div>
                          <div>
                            Blanching:{" "}
                            <span className={getYesNoClass(renderBool(lesion?.blanching))}>
                              {renderBool(lesion?.blanching)}
                            </span>
                          </div>
                          <div>
                            Epidermal Breakage:{" "}
                            <span className={getYesNoClass(renderBool(lesion?.epidermalBreakage))}>
                              {renderBool(lesion?.epidermalBreakage)}
                            </span>
                          </div>
                          <div>
                            Itchy:{" "}
                            <span className={getYesNoClass(renderBool(lesion?.itchy))}>
                              {renderBool(lesion?.itchy)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        )}

        {/* --- Atopic Dermatitis --- */}
        {props.showADTab && activeSubTab === "ad" && (
          <div className="finding-card atopic-card">
            <div className="card-header">
              <h4>Atopic Dermatitis</h4>
            </div>

            <div className="card-body multi-column">
              {/* LEFT SIDE */}
              <div>
                <p>
                  <strong>IgE Count:</strong>{" "}
                  <strong className="highlight">
                    {igeCount !== null ? igeCount : "--"}
                  </strong>
                </p>

                <p>
                  <strong>Allergic Rhinitis Risk:</strong>{" "}
                  <span className={hasPruritus ? "yes-text" : "no-text"}>
                    {hasPruritus ? "Yes" : "No"}
                  </span>
                </p>

                <p>
                  <strong>Major Symptoms:</strong>
                </p>

                <div className="two-column-grid">
                  <div>
                    Pruritus:
                    <span className={hasPruritus ? "yes-text" : "no-text"}>
                      {hasPruritus === null ? "--" : hasPruritus ? "Yes" : "No"}
                    </span>
                  </div>

                  <div>
                    Chronic Relapsing:
                    <span
                      className={hasChronicRelapsing ? "yes-text" : "no-text"}
                    >
                      {hasChronicRelapsing === null
                        ? "--"
                        : hasChronicRelapsing
                          ? "Yes"
                          : "No"}
                    </span>
                  </div>

                  <div>
                    Typical Morphology:
                    <span
                      className={hasTypicalMorphology ? "yes-text" : "no-text"}
                    >
                      {hasTypicalMorphology === null
                        ? "--"
                        : hasTypicalMorphology
                          ? "Yes"
                          : "No"}
                    </span>
                  </div>

                  <div>
                    Family History:
                    <span className={hasFamilyHistory ? "yes-text" : "no-text"}>
                      {hasFamilyHistory === null
                        ? "--"
                        : hasFamilyHistory
                          ? "Yes"
                          : "No"}
                    </span>
                  </div>
                </div>
              </div>

              {/* RIGHT SIDE */}
              <div>
                <p>
                  <strong>Minor Symptoms:</strong>
                </p>

                <div className="two-column-grid">
                  <div>
                    Erythema:
                    <span
                      className={
                        minorSymptoms["facial_pallor"] ? "yes-text" : "no-text"
                      }
                    >
                      {minorSymptoms["facial_pallor"] ? "Yes" : "No"}
                    </span>
                  </div>

                  <div>
                    Pityriasis Alba:
                    <span
                      className={
                        minorSymptoms["pityriasis_alba"]
                          ? "yes-text"
                          : "no-text"
                      }
                    >
                      {minorSymptoms["pityriasis_alba"] ? "Yes" : "No"}
                    </span>
                  </div>

                  <div>
                    Eyelid Darkening:
                    <span
                      className={
                        minorSymptoms["darkening_around_the_eyelids"]
                          ? "yes-text"
                          : "no-text"
                      }
                    >
                      {minorSymptoms["darkening_around_the_eyelids"]
                        ? "Yes"
                        : "No"}
                    </span>
                  </div>

                  <div>
                    Dennie-Morgan Folds:
                    <span
                      className={
                        minorSymptoms["infra_orbital_folds"]
                          ? "yes-text"
                          : "no-text"
                      }
                    >
                      {minorSymptoms["infra_orbital_folds"] ? "Yes" : "No"}
                    </span>
                  </div>

                  <div>
                    Cheilitis:
                    <span
                      className={
                        minorSymptoms["dry_lips"] ? "yes-text" : "no-text"
                      }
                    >
                      {minorSymptoms["dry_lips"] ? "Yes" : "No"}
                    </span>
                  </div>

                  <div>
                    Anterior Neck-Folds:
                    <span
                      className={
                        minorSymptoms["anterior_neck_folds"]
                          ? "yes-text"
                          : "no-text"
                      }
                    >
                      {minorSymptoms["anterior_neck_folds"] ? "Yes" : "No"}
                    </span>
                  </div>

                  <div>
                    Ichthyosis:
                    <span
                      className={
                        minorSymptoms["ichthyosis"] ? "yes-text" : "no-text"
                      }
                    >
                      {minorSymptoms["ichthyosis"] ? "Yes" : "No"}
                    </span>
                  </div>

                  <div>
                    Hyper Linear Palms:
                    <span
                      className={
                        minorSymptoms["increased_palmar_lines"]
                          ? "yes-text"
                          : "no-text"
                      }
                    >
                      {minorSymptoms["increased_palmar_lines"] ? "Yes" : "No"}
                    </span>
                  </div>

                  <div>
                    Hand & Foot Eczema:
                    <span
                      className={
                        minorSymptoms["hand_and_foot_eczema"]
                          ? "yes-text"
                          : "no-text"
                      }
                    >
                      {minorSymptoms["hand_and_foot_eczema"] ? "Yes" : "No"}
                    </span>
                  </div>

                  <div>
                    Nipple Eczema:
                    <span
                      className={
                        minorSymptoms["nipple_eczema"] ? "yes-text" : "no-text"
                      }
                    >
                      {minorSymptoms["nipple_eczema"] ? "Yes" : "No"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DermSummaryTab;